export const GUI_CONST = {
    main_id : 'main',
    header_id : 'scratch3Header',
    header_class : 'scratch3Header',
    controlsContainer_class: 'controls_controls-container',
    headerMenu_class : 'scratch3HeaderMenu',
    greenFlag_id : 'green-flag_green-flag',
    greenFlag_class : 'green-flag_green-flag',
    canvas_id : 'canvas',
    canvas_class: 'likeScratch-canvas',
    canvas_div_id: 'canvasDiv',
    canvas_div_class : 'likeScratch-canvas',
    stageCanvasWrapper: 'stageCanvasWrapper',
    ControlStopMark:"stop-all_stop-all_pluqe",
    ControlPauseMark : "pause-button",
    Overlay: "scratch3-overlay",
    Overlay_image: "scratch3-overlay-image",
    Overlay_image_image: "scratch3-overlay-image-image",
    
}